import redX from "../../images/redX.svg";
import classes from "./ResetPassword.module.css";
import greenCheck from "../../images/greenCheck.svg";
import { ActionBtn } from "../../components/buttons/actionBtn/ActionBtn";
import { BackToLoginBtn } from "../../components/buttons/backToLoginBtn/BackToLoginBtn";
import { LoadingSpinner } from "../../components/loadingSpinner/LoadingSpinner";
import { BaseLoginInput } from "../../components/UI/baseLoginInput/BaseLoginInput";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { LanguageSwitcher } from "../../components/languageSwitcher/LanguageSwitcher";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  resetPassword,
  resetPasswordState,
} from "../../redux/resetPass/resetPass";

export function ResetPassword() {
  const [token, setToken] = useState("");
  const [newPass, setNewPass] = useState("");
  const [hasTyped, setHasTyped] = useState(false);
  const [confirmPass, setConfirmPass] = useState("");

  const { t } = useTranslations();

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const resetPassPage = t.resetPassPage;

  const resetPassState = useSelector((state) => state.resetPassword);

  // Function for validating the token
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get("token");

    if (tokenParam) {
      setToken(tokenParam);
    } else {
      navigate("/login");
    }
  }, [location, dispatch, navigate]);

  const validations = {
    hasUpper: /[A-Z]/.test(newPass),
    hasLower: /[a-z]/.test(newPass),
    hasDigit: /\d/.test(newPass),
    hasMinLength: newPass.length >= 8,
    passwordsMatch: newPass !== "" && newPass === confirmPass,
  };

  const validationItems = [
    {
      label: resetPassPage.hasUpper,
      isValid: validations.hasUpper,
    },
    {
      label: resetPassPage.hasLower,
      isValid: validations.hasLower,
    },
    {
      label: resetPassPage.hasDigit,
      isValid: validations.hasDigit,
    },
    {
      label: resetPassPage.hasMinLength,
      isValid: validations.hasMinLength,
    },
    {
      label: resetPassPage.passwordsMatch,
      isValid: validations.passwordsMatch,
    },
  ];

  function onPassReset(e) {
    e.preventDefault();

    const allValid = validationItems.every((item) => item.isValid);

    if (!allValid) {
      return;
    }

    dispatch(
      resetPassword({
        new_password: newPass,
        confirm_password: confirmPass,
        token: token,
      })
    );
  }

  useEffect(() => {
    if (resetPassState.status === "error") {
      setTimeout(() => {
        dispatch(resetPasswordState());
      }, 2500);
    }
  }, [resetPassState.status, dispatch]);

  const isStatusLoading = resetPassState.status === "loading";
  const isBtnDisabled = isStatusLoading || !newPass || !confirmPass;

  return (
    <section className={`${classes.resetPassContainer} fadeIn`}>
      <div className={classes.logo}>
        <div className={classes.box}></div>
        <div className={classes.overlay}></div>
      </div>
      <div className={classes.languageSwitcherContainer}>
        <LanguageSwitcher />
      </div>
      {resetPassState.status === "success" ? (
        <div className={classes.passChanged}>
          <h2>{resetPassPage.passChanged.heading}</h2>
          <p>{resetPassPage.passChanged.message}</p>
          <Link to={"/login"} className={classes.backToLoginBtn}>
            {resetPassPage.passChanged.backToLoginBtn}
          </Link>
        </div>
      ) : (
        <form className={classes.resetPassForm} onSubmit={onPassReset}>
          <h2>{resetPassPage.resetPassForm.heading}</h2>
          <p>{resetPassPage.resetPassForm.instruction}</p>
          <div className={classes.inputs}>
            <BaseLoginInput
              label={resetPassPage.resetPassForm.newPasswordLabel}
              name={"newPass"}
              type={"password"}
              value={newPass}
              onChange={(e) => {
                setNewPass(e.target.value), setHasTyped(true);
              }}
            />
            <BaseLoginInput
              label={resetPassPage.resetPassForm.confirmPasswordLabel}
              name={"confirmNewPass"}
              type={"password"}
              value={confirmPass}
              onChange={(e) => {
                setConfirmPass(e.target.value), setHasTyped(true);
              }}
            />
            <ul className={classes.validationList}>
              {validationItems.map((item, i) => {
                let icon = null;
                let className = classes.neutral;

                if (hasTyped) {
                  icon = item.isValid ? (
                    <img src={greenCheck} />
                  ) : (
                    <img src={redX} />
                  );
                  className = item.isValid ? classes.valid : classes.invalid;
                }

                return (
                  <li key={i} className={className}>
                    {icon} {item.label}
                  </li>
                );
              })}
            </ul>

            <ActionBtn
              type="submit"
              width={"100%"}
              height={"50px"}
              disabled={isBtnDisabled}
              text={
                isStatusLoading ? (
                  <LoadingSpinner black={true} />
                ) : (
                  resetPassPage.resetPassForm.createPasswordButton
                )
              }
            />
          </div>

          <BackToLoginBtn />
          <div
            className={classes.errorNotification}
            style={{
              opacity: resetPassState.status === "error" ? 1 : 0,
              pointerEvents:
                resetPassState.status === "error" ? "auto" : "none",
            }}
          >
            {resetPassState.error}
          </div>
        </form>
      )}
    </section>
  );
}
